module.exports = __webpack_public_path__ + "static/media/swimming-silver-yeti.10437cc0.png";